<template>
  <div>
    <div class="header">
      <p
        v-for="(item, i) in activeList"
        :key="i"
        :class="{ isActive: activeindex === i  }"
        @click="changeActive(i)"
       
      >
        {{ item.name }}
      </p>
    </div>

    <rank-scroll
      url="game/rank"
      :params="{ otype: 1 }"
      :method="'get'"
      v-if="activeindex == 0"
    >
      <template slot-scope="scope">
        <div class="gameConetent">
          <div class="item" v-for="(item, i) in scope.data" :key="i" @click="gotoGame(item.app_id)">
            <p :class="['rankNumber','rankNumber_' + i]">{{ i + 1 }}</p>
            <P class="picImg"><img :src="item.icon" alt="" /></P>
            <div class="right">
              <div class="title">
                <h3>{{ item.app_name }}</h3>
                <!-- <p>近7日在线人数8888</p> -->
              </div>
              <div class="content">
                <p v-html="replaceAll(item.intro)"></p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </rank-scroll>

    <rank-scroll
      url="game/rank"
      :params="{ otype: 2 }"
      :method="'get'"
      v-if="activeindex == 1"
    >
      <template slot-scope="scope">
        <div class="gameConetent">
          <div class="item" v-for="(item, i) in scope.data" :key="i" @click="gotoGame(item.app_id)">
            <p :class="['rankNumber','rankNumber_' + i]">{{ i + 1 }}</p>
            <P class="picImg"><img :src="item.icon" alt="" /></P>
            <div class="right">
              <div class="title">
                <h3>{{ item.app_name }}</h3>
                <!-- <p>近7日在线人数8888</p> -->
              </div>
              <!-- <div class="content">
                <p>S32全新赛手[漂泊之剑]正式开启</p>
                <p>近7日成交人数8888</p>
              </div> -->
            </div>
          </div>
        </div>
      </template>
    </rank-scroll>
  </div>
</template>

<script>
export default {
  props:{
    activeindex:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      active:0,
      activeList: [
        {
          name: "成交量",
          i: 0,
        },
        {
          name: "成交额",
          i: 1,
        },
      ],
      otype: 0,
      
    };
  },
  created() {},
  mounted() {},
  methods: {
    replaceAll(str){
      if(str) {
        return str.replace(new RegExp('&nbsp;','g'),'');
      }else {
        return ''
      }
    },
    changeActive(i) {
      this.otype = i
      this.$emit('updateActiveindex', i)
    },
    gotoGame(app_id) {
      this.$router.push({
        name: 'detail',
        query: {
          app_id
        }
      })
    }
  },

  computed: {},
};
</script>

<style scoped lang="less">
div {
  .header {
    width: 50%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    border-radius: 1.5rem;
    background-color: #ddd;
    margin-top: 1rem;
    color: #666;

    p {
      width: 50%;
      height: 3rem;
      border-radius: 1.5rem;
      text-align: center;
      line-height: 3rem;
      cursor: pointer;
    }

    .isActive {
      background: white;
      color: #fe5547;
      font-weight: 800;
    }
  }

  .item {
    width: 35rem;
    background-color: white;
    border-radius: 0.85rem;
    margin: 1rem;
    display: flex;
    align-items: center;
    padding: 1rem 1.5rem;

    .rankNumber {
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 10rem;
      background-color: rgb(255, 195, 31);
      margin-right: 1rem;
      text-align: center;
      line-height: 2.4rem;
      font-size: 1.6rem;
      font-weight: 700;
      color: #fff;
      position: relative;
      &.rankNumber_0 {
        background-color: #ff2d23;
        &::after {
          content: '';
          position: absolute;
          left: -0.5rem;
          top: -1.4rem;
          width: 1.6rem;
          height: 1.6rem;
          background: url(../../../assets/rank/hg_1.png) no-repeat 0 0 / 100% 100%;
          transform: rotate(-20deg);
        }
      }
      &.rankNumber_1 {
        background-color: #fe6960;
        &::after {
          content: '';
          position: absolute;
          left: -0.5rem;
          top: -1.4rem;
          width: 1.6rem;
          height: 1.6rem;
          background: url(../../../assets/rank/hg_2.png) no-repeat 0 0 / 100% 100%;
          transform: rotate(-20deg);
        }
      }
      &.rankNumber_2 {
        background-color: #fc8e72;
        &::after {
          content: '';
          position: absolute;
          left: -0.5rem;
          top: -1.4rem;
          width: 1.6rem;
          height: 1.6rem;
          background: url(../../../assets/rank/hg_3.png) no-repeat 0 0 / 100% 100%;
          transform: rotate(-20deg);
        }
      }
    }

    .picImg {
      width: 5rem;
      height: 5rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      margin-left: 1rem;
      width: 22rem;

      .title {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        h3 {
          margin-right: 0.5rem;
          width: 100%;
        }

        p {
          width: 14rem;
          height: 2rem;
          display: flex;
          flex-wrap: wrap;
          background-color: #fe5544;
          color: white;
          text-align: center;
          line-height: 2rem;
          border-radius: 0.85rem;
          padding-left: .3rem;
        }
      }

      .content {
        margin-top: 0.3rem;

        p {
          color: #bebebe;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          /deep/img,
          /deep/.img,
          /deep/.image {
            display: none;
          }
        }
      }
    }
  }
}
</style>
